import { render, staticRenderFns } from "./BgAudio.vue?vue&type=template&id=7ac80bb4&scoped=true"
import script from "./BgAudio.vue?vue&type=script&lang=js"
export * from "./BgAudio.vue?vue&type=script&lang=js"
import style0 from "./BgAudio.vue?vue&type=style&index=0&id=7ac80bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac80bb4",
  null
  
)

export default component.exports